import { defineComponent as _defineComponent } from 'vue'
import VehicleOptionVehicleList from "@/components/VehicleOptionVehicleList.vue";
import VehicleOptionImage from "@/components/VehicleOptionImage.vue";
import { computed } from "vue";
import { VehicleTypeKey } from "@/utils/enum";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotTripSummaryVehicles',
  props: {
    vehicles: null
  },
  setup(__props: any) {

const props = __props as {
  vehicles: { quantity: number; vehicleTypeKey: string }[],
};



const vehicleTypeKeys = computed((): string[] =>
  props.vehicles.map(({ vehicleTypeKey }) => vehicleTypeKey)
)

return { __sfc: true,props, vehicleTypeKeys, VehicleOptionVehicleList, VehicleOptionImage }
}

})